// 临时把配置内容放这里
export default {
    "REACT_APP_DEBUG":(process.env.REACT_APP_DEBUG == 'true'),
    "REACT_APP_GATEWAY_URL":process.env.REACT_APP_GATEWAY_URL,
    "REACT_APP_ELONG_GATEWAY_URL":process.env.REACT_APP_ELONG_GATEWAY_URL,
    "REACT_APP_EDITION":process.env.REACT_APP_EDITION,
    "REACT_APP_GOODS":process.env.REACT_APP_GOODS,
    "REACT_APP_TERRACE":process.env.REACT_APP_TERRACE,
    "REACT_APP_XBED_SECRET_TOKEN":process.env.REACT_APP_EDITION,
    "REACT_APP_XBED_SECRET_KEY":process.env.REACT_APP_XBED_SECRET_KEY,
    REACT_APP_MINI_TERRACE:process.env.REACT_APP_MINI_TERRACE,
    REACT_APP_MINI_EDITION:process.env.REACT_APP_MINI_EDITION,
    "XBED_WEBSITE": process.env.REACT_APP_XBED_WEBSITE,
    "XBED_STATIC": process.env.REACT_APP_XBED_STATIC
}


// WEBPACK FOOTER //
// ./src/config.js